var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlinkSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.625,
    y: 0,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(-90 0 9)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.825,
    y: 16.5,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(-150 4.825 16.5)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.825,
    y: 16.125,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(150 13.825 16.125)",
    fill: "#EFEFEF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.982,
    y: 12.75,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(120 16.982 12.75)",
    fill: "#D4D4D4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.607,
    y: 4.5,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(60 16.607 4.5)",
    fill: "#B0B0B0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 18,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(180 9.375 18)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8.625,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(90 18 8.625)",
    fill: "#CDCDCD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.175,
    y: 1.5,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(30 13.175 1.5)",
    fill: "#B6B6B6"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 4.175,
    y: 1.5,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(-30 4.175 1.5)",
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1.018,
    y: 5.25,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(-60 1.018 5.25)",
    fill: "#EFEFEF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1.393,
    y: 13.5,
    width: 0.75,
    height: 4.5,
    rx: 0.375,
    transform: "rotate(-120 1.393 13.5)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlinkSpinner);
export default __webpack_public_path__ + "static/media/blink-spinner.c1dacd26c17e76d0d12e23e87c9e307f.svg";
export { ForwardRef as ReactComponent };